import React from "react";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {RequestDeleteFolder} from "../../Actions/referentiel.action";
import "./referentiel.css";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import {Folder, FolderOpen, Trash2} from "lucide-react";

const UNCATEGORIZED_KEY = "__uncategorized__"; // ✅ Constante pour identifier "Non classé"

export default function Sidebar({
    folders,
    selectedKey,
    onSelectFolder,
    folderStats = {},
}) {
    const dispatch = useDispatch();
    const {t} = useTranslation("referentiel");
    const documents = useSelector((state) => state.files.documents);

    return (
        <div className="sidebar-doc-upload">
            <div className="sidebar-doc-header">
                <h2>{t("sidebar.title", "Dossiers")}</h2>
                <span className="sidebar-doc-total">{folders.length}</span>
            </div>

            <div className="folder-tree">
                {folders.map((folder) => {
                    // ✅ Vérifier si c'est le dossier "Non classé"
                    const isUncategorized = folder.key === UNCATEGORIZED_KEY;
                    const isActive = selectedKey === folder.key;
                    const count = folderStats[folder.key] || 0;

                    return (
                        <div
                            key={folder.key}
                            className={`folder-item ${isActive ? "active" : ""}`}
                        >
                            <button
                                type="button"
                                className="folder-select-button"
                                onClick={() => onSelectFolder(folder.key)}
                                aria-pressed={isActive}
                            >
                                <span className="folder-icon" aria-hidden="true">
                                    {isActive ? <FolderOpen size={18}/> : <Folder size={18}/>}
                                </span>
                                <span className="folder-title">
                                    {isUncategorized ? t("newFolder.uncategorized") : folder.title}
                                </span>
                                <span className="folder-count">{count}</span>
                            </button>

                            {/* ✅ Afficher la corbeille SEULEMENT si ce n'est PAS "Non classé" */}
                            {!isUncategorized && (
                                <button
                                    type="button"
                                    className="delete-folder-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const filesInFolder = documents.filter((doc) => {
                                            const docFolder = doc.folder?.trim() || UNCATEGORIZED_KEY;
                                            return docFolder === folder.key;
                                        });

                                        Modal.confirm({
                                            title: t("newFolder.confirmDelete", {
                                                name: folder.title
                                            }),
                                            icon: <ExclamationCircleOutlined/>,
                                            content: (
                                                <div>
                                                    <p>{t("folder.deleteWarning")}</p>
                                                    <ul style={{maxHeight: "200px", overflowY: "auto", paddingLeft: "1.2rem"}}>
                                                        {filesInFolder.map((file) => (
                                                            <li key={file.id}>{file.title}</li>
                                                        ))}
                                                    </ul>
                                                    <p style={{
                                                        marginTop: "1rem",
                                                        color: "#ff4d4f"
                                                    }}>{t("folder.irreversible")}</p>
                                                </div>
                                            ),
                                            okText: t("actions.delete"),
                                            okType: "danger",
                                            cancelText: t("actions.cancel"),
                                            centered: true,
                                            onOk: () => {
                                                dispatch(RequestDeleteFolder(folder.key));
                                                if (selectedKey === folder.key) onSelectFolder(null);
                                            },
                                        });
                                    }}
                                    aria-label={t("actions.delete")}
                                >
                                    <Trash2 size={14}/>
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
